import { ReactNode } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { useAtomValue } from "jotai";
import { filterSidebarAtom } from "../../atoms/filterSidebarAtom";

interface FilterSidebarLayoutProps {
  children: ReactNode;
}

/**
 * Layout component that properly handles content spacing when filter sidebar is open.
 * On desktop (lg+): Content is pushed to the right when sidebar is open (permanent variant)
 * On mobile/tablet: Content stays full width with sidebar as overlay (temporary variant)
 */
export function FilterSidebarLayout({ children }: FilterSidebarLayoutProps) {
  const theme = useTheme();
  const open = useAtomValue(filterSidebarAtom);
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  // On desktop with permanent sidebar, add margin to prevent content overlap
  const marginLeft = !isMobile && open ? "360px" : 0;

  return (
    <Box
      sx={{
        marginLeft,
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open &&
          !isMobile && {
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
        width: !isMobile && open ? "calc(100% - 360px)" : "100%",
        boxSizing: "border-box",
      }}
    >
      {children}
    </Box>
  );
}
